import React from 'react';
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const KeyValueStacked = (props) => {
    const {pairs, spacing, keyTextVariant, valueTextVariant} = props;

    return (
        <Grid container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={spacing || 0}>
            {
                pairs.map(([k, v], i) => (
                    <Grid item key={i} xs={12}>
                        <Typography variant={keyTextVariant || "caption"} color="textSecondary">
                            {k}
                        </Typography>
                        <Typography variant={valueTextVariant || "body2"}>
                            {v}
                        </Typography>
                    </Grid>
                ))
            }
        </Grid>
    )
};

KeyValueStacked.propTypes = {
    pairs: PropTypes.arrayOf(PropTypes.arrayOf).isRequired,
    spacing: PropTypes.number, keyTextVariant: PropTypes.string,
    valueTextVariant: PropTypes.string,
};

export default KeyValueStacked;